import { Msg } from 'react-weui';
const Config = {
  404: '页面不存在',
  not: '请在微信客户端打开链接',
  pc: '移动端暂不支持，请在PC端操作'
};

function ErrorPage(props) {
  let type = props.type || 'not';
  let errorMsg = Config[type];

  return <Msg type="warn" title={errorMsg} />;
}

export default ErrorPage;
